// Macht aus den Rohdaten des Servers, was der Lehrer liest.
// Gespeichert werden nur pruefungen + ergebnis; die Bezeichnungen entstehen hier.

// Die Spalten der Klassenansicht, je Thema. Funkaufgaben sind eine freie Liste
// ohne Pruefen und ohne Ueberspringen: nur erledigt oder offen.
export const spalten = {
    sprechregeln: [
        { id: 'richtig', label: 'Richtig beim 1. Mal' },
        { id: 'nachgebessert', label: 'Falsch, nachgebessert' },
        { id: 'falschUebersprungen', label: 'Falsch, übersprungen' },
        { id: 'uebersprungen', label: 'Übersprungen ohne Versuch' },
        { id: 'offen', label: 'Offen' }
    ],
    funk: [
        { id: 'erledigt', label: 'Erledigt' },
        { id: 'offen', label: 'Offen' }
    ]
}

export function bezeichnung(eintrag) {
    const { typ, pruefungen, ergebnis } = eintrag
    if (ergebnis === 'offen') return 'offen'
    if (typ === 'funk') return 'erledigt'
    if (ergebnis === 'richtig') return pruefungen <= 1 ? 'richtig' : 'nachgebessert'
    return pruefungen > 0 ? 'falschUebersprungen' : 'uebersprungen'
}

// Eine Zeile je Kategorie, mit der Anzahl je Spalte. Eine Aufgabe in zwei
// Kategorien zaehlt in beiden. Ohne Kategorien gibt es eine Zeile "Alle".
export function proKategorie(uebersicht) {
    return zeilenNach(uebersicht, e => e.kategorien.length > 0 ? e.kategorien : ['Alle'])
}

// Dasselbe je Uebungsart (nur Sprechregeln). "namen" uebersetzt die id in den
// Namen, den der Lehrer kennt. Eintraege ohne Art stammen von vor den
// Uebungsarten und waren "Alles sortieren".
export function proUebungsart(uebersicht, namen) {
    return zeilenNach(uebersicht, e => [namen[e.art ?? 'allesSortieren'] ?? e.art])
}

// schluessel(eintrag) -> Liste der Zeilen, in denen der Eintrag zaehlt.
function zeilenNach(uebersicht, schluessel) {
    const thema = uebersicht.konfiguration.thema
    const zeilen = new Map()
    for (const schueler of uebersicht.schueler) {
        for (const eintrag of schueler.stand) {
            for (const k of schluessel(eintrag)) {
                if (!zeilen.has(k)) {
                    zeilen.set(k, Object.fromEntries(spalten[thema].map(s => [s.id, 0])))
                }
                zeilen.get(k)[bezeichnung(eintrag)]++
            }
        }
    }
    return [...zeilen].map(([kategorie, anzahl]) => ({ kategorie, anzahl }))
}

// Fortschritt eines Schuelers. Wer noch nichts geschickt hat, hat einen leeren
// Stand — gezaehlt wird dann gegen die konfigurierte Anzahl.
export function fortschritt(schueler, konfiguration) {
    const bearbeitet = schueler.stand.filter(e => e.ergebnis !== 'offen').length
    const ersteOffene = schueler.stand.findIndex(e => e.ergebnis === 'offen')
    return {
        bearbeitet,
        gesamt: konfiguration.anzahl,
        fertig: bearbeitet === konfiguration.anzahl,
        // 1-basiert, so wie der Schueler die Aufgaben zaehlt. Ohne offene
        // Eintraege (noch nichts geschickt) ist es die naechste nach den bearbeiteten.
        aktuell: ersteOffene !== -1
            ? ersteOffene + 1
            : (bearbeitet < konfiguration.anzahl ? bearbeitet + 1 : null),
        uebersprungen: schueler.stand.filter(e => e.ergebnis === 'uebersprungen').length
    }
}

export function vorWieLange(zeitpunkt, jetzt = Date.now()) {
    const sekunden = Math.max(0, Math.round((jetzt - zeitpunkt) / 1000))
    if (sekunden < 60) return `vor ${sekunden} s`
    return `vor ${Math.round(sekunden / 60)} min`
}
